/** @jsx isolateComponent */

import { Fragment } from 'react';
import { Button } from '@zapier/design-system';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { loginPath, signupPath } from '../../constants';

import UniversalTopbarLink from './UniversalTopbarLink';

type Props = {
  /**
   * `Href` to login button.
   */
  loginHref: string;
  /**
   * Currently navigated to url.
   */
  selectedHref: string;
  /**
   * Indicates whether Log in button should render.
   */
  shouldRenderSignIn: boolean;
  /**
   * Indicates whether Sign up button should render.
   */
  shouldRenderSignUp: boolean;
  /**
   * The size of the component, which influences the size of its buttons.
   */
  size: 'small' | 'medium';
  /**
   * `Href` to signup button.
   */
  signupHref: string;
};

const Styles = labelStyles('AccountActions', {
  signupButton: {
    minWidth: 100,
  },
});

/**
 * @private
 * Conditionally renders a login link and sign up button.
 */
export const AccountActions = (props: Props) => {
  const { trackEvent } = useTrackingContext();
  const signupPreintentEvent = () => {
    trackEvent('call_to_action', {
      path: window.location.pathname,
      from_path: document.referrer,
      cta_name: 'signup_pre_intent',
      cta_raw_text: 'sign up',
      cta_location: 'navbar',
      cta_goal: 'signup',
      signup_type: '',
      link_destination: '/sign-up',
    });
  };
  return (
    <Fragment>
      {props.shouldRenderSignIn && (
        <UniversalTopbarLink
          href={props.loginHref}
          isSelected={props.selectedHref.includes(props.loginHref)}
        >
          Log in
        </UniversalTopbarLink>
      )}
      {props.shouldRenderSignUp && (
        <div css={Styles.signupButton}>
          <Button
            color="primary"
            hasShadow={true}
            href={props.signupHref}
            id="universalnav-signup"
            isFullWidth={true}
            onClick={signupPreintentEvent}
            size="small"
          >
            Sign up
          </Button>
        </div>
      )}
    </Fragment>
  );
};

AccountActions.defaultProps = {
  loginHref: loginPath,
  selectedHref: '',
  signupHref: signupPath,
  size: 'medium',
};

export default AccountActions;
